import React from "react";
import { PanelGroup, Panel } from "../../compat/PanelCompat";
import PackageUsers from '../../packageUsers'
import RppPackageZones from './rppPackageZones'
import PackageAddons from '../../packageAddons'
import UsersActive from '../../../../image/Icons/Users-active.svg'
import ZonesDefault from '../../../../image/Icons/Zones-default.svg'
import ZonesActive from '../../../../image/Icons/Zones-active.svg'
import ZonesDeactive from '../../../../image/Icons/Zones-inactive.svg'
import AddonsDefault from '../../../../image/Icons/Add-Ons-default.svg'
import AddonsActive from '../../../../image/Icons/Add-Ons-active.svg'
import AddonsInactive from '../../../../image/Icons/Add-Ons-inactive.svg'
import './RPPProductConfig.css';


export default class RppProductConfig extends React.Component{
  constructor(props){
    super(props);
    this.handleSelect = this.handleSelect.bind(this);

    if(this.props.onSelectingUser !== undefined){
      this.onSelectingUser = this.props.onSelectingUser.bind(this);
    }
    this.onUserClickAction = this.onUserClickAction.bind(this);

    if(this.props.onSelectingGeography !== undefined){
      this.onSelectingGeography = this.props.onSelectingGeography.bind(this);
    }
    this.onGeographyClickAction = this.onGeographyClickAction.bind(this);
    if(this.props.onSelectingAddons !== undefined){
      this.onSelectingAddons = this.props.onSelectingAddons.bind(this);
    }

    this.state = {
      mobile: false,
      activeKey: this.props.productPackageConfig && this.props.productPackageConfig.users.max_users === '1'? '2' : '1'
    };
  }

  componentDidMount() {
    if(/Android|webOS|iPhone|iPod|ipad|BlackBerry/i.test(navigator.userAgent) ){
      this.setState({
        mobile: true,
       });
    }
  }

  handleSelect(activeKey) {
    this.setState({ activeKey });
  }

  onUserClickAction(){
    this.setState({
      activeKey: '2'
    });
  }

  onGeographyClickAction(){
    this.setState({
      activeKey: '3'
    });
  }

  render(props){
    var zones = ''
    if (this.props.productPackageConfig.geography && this.props.productPackageConfig.geography.national === true &&
      this.props.productPackageDefaultConfig.configuration.industry==='real_estate_agencies_and_valuers' &&
      (this.props.productPackageDefaultConfig.configuration.package==='pro' || this.props.productPackageDefaultConfig.configuration.package==='premium')) {
        zones='hidden'
    } else if(this.props.productPackageDefaultConfig.configuration.geography.national === false &&
      this.props.productPackageDefaultConfig.configuration.geography.states === null &&
      this.props.productPackageDefaultConfig.configuration.package!=='trial' &&
      this.state.activeKey!=='2'){
        zones='inactive'
    } else if(this.props.productPackageDefaultConfig.configuration.geography.national === true ||
      this.props.productPackageDefaultConfig.configuration.geography.states !== null ||
      this.props.productPackageDefaultConfig.configuration.package==='trial'){
        zones='active'
    } else if(this.props.productPackageDefaultConfig.configuration.geography.national === false &&
      this.props.productPackageDefaultConfig.configuration.geography.states === null &&
      this.props.productPackageDefaultConfig.configuration.package!=='trial' &&
      this.state.activeKey==='2'){
        zones='default'
    }
    let classNames = require('classnames');
    var zonesTileClass = classNames({
      'white-bg': zones !== 'inactive',
      'off-white-bg': zones === 'inactive'
    });

    var addonsTileClass = classNames({
      'white-bg': this.props.productPackageDefaultConfig.configuration.addons.length>0 || this.state.activeKey === '3',
      'off-white-bg': this.props.productPackageDefaultConfig.configuration.addons.length===0 && this.state.activeKey !== '3'
    });

    return (
      <div className="row white-bg padding-20">
        <div className="col-sm-12 no-padding">
          <PanelGroup
            accordion
            id="product-config-accordion"
            activeKey={this.state.activeKey}
            onSelect={this.handleSelect}
          >
            <Panel eventKey="1">
              <Panel.Heading className="white-bg">
                <Panel.Title toggle>
                  <div type="button" className="row panel-title panel-button no-margin">
                    <div className="col-xs-7 text-left text-success no-padding">
                      <img src={UsersActive} alt="" className="margin-right-5"/>
                       Users
                    </div>
                    <div style={{"lineHeight": "30px"}} className="col-xs-5 text-right text-success no-padding">
                      {this.props.productPackageDefaultConfig.configuration.number_of_users!==null &&
                        <span>{this.props.productPackageDefaultConfig.configuration.number_of_users} {this.props.productPackageDefaultConfig.configuration.number_of_users===1?"User":"Users"} </span>
                      }
                      {this.state.activeKey!=='1' &&
                        <span className="float-right carat-down" aria-hidden="true"></span>
                      }
                      {this.state.activeKey==='1' &&
                        <span className="float-right carat-up" aria-hidden="true"></span>
                      }
                    </div>
                  </div>
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body collapsible>
                {
                  this.props.productPackageConfig &&
                  <PackageUsers
                    users={this.props.productPackageConfig.users}
                    selectedUser={this.props.productPackageDefaultConfig.configuration.number_of_users}
                    onSelectingUser = {this.onSelectingUser}
                    onUserClickAction = {this.onUserClickAction}
                  />
                }

              </Panel.Body>
            </Panel>
            {
              zones !== "hidden" &&
            <Panel eventKey="2">
              <Panel.Heading className={zonesTileClass}>
                <Panel.Title toggle>
                  <div type="button" className="row panel-title panel-button no-margin">
                    <div className="col-xs-8 text-left no-padding">
                      {
                        zones==='default' &&
                        <span><img src={ZonesDefault} alt="" className="margin-right-5"/>
                        <span>Zones</span></span>
                      }
                      {
                        zones==='active' &&
                        <span><img src={ZonesActive} alt="" className="margin-right-5"/>
                        <span className="text-success">Zones</span></span>
                      }
                      {
                        zones==='inactive' &&
                        <span><img src={ZonesDeactive} alt="" className="margin-right-5"/>
                        <span className="tan-text">Zones</span></span>
                      }

                    </div>
                    <div className="col-xs-4 text-right no-padding">
                      <span style={{"lineHeight": "30px"}}>
                        {
                          this.props.productPackageDefaultConfig.configuration.geography.national &&
                          <span className="text-success">National </span>
                        }
                        {
                          this.props.productPackageDefaultConfig.configuration.package==='trial' &&
                          <span className="text-success">Limited </span>
                        }
                        {
                          this.props.productPackageDefaultConfig.configuration.geography.states!=null &&
                          this.props.productPackageDefaultConfig.configuration.geography.states.map(function(state,index){
                            return(
                              <span className="text-success" key={index}>{state}. </span>
                            )
                          })
                        }
                      </span>
                      {this.state.activeKey!=='2' &&
                        zones==='default' &&
                        <span className="panel-dropdown-icon carat-down" aria-hidden="true"></span>
                      }
                      {this.state.activeKey==='2' &&
                        zones==='default' &&
                        <span className="panel-dropdown-icon carat-up" aria-hidden="true"></span>
                      }
                      {this.state.activeKey!=='2' &&
                      zones==='active' &&
                        <span className="panel-dropdown-icon carat-down text-success" aria-hidden="true"></span>
                      }
                      {this.state.activeKey==='2' &&
                        zones==='active' &&
                        <span className="panel-dropdown-icon carat-up text-success" aria-hidden="true"></span>
                      }
                      {this.state.activeKey!=='2' &&
                        zones==='inactive' &&
                        <span className="panel-dropdown-icon carat-down tan-text" aria-hidden="true"></span>
                      }
                    </div>
                  </div>
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body collapsible>
                {
                  this.props.productPackageConfig &&
                  <RppPackageZones
                    geography={this.props.productPackageConfig.geography}
                    selectedGeography={this.props.productPackageDefaultConfig.configuration.geography}
                    selectedPackage={this.props.productPackageDefaultConfig.configuration.package}
                    onSelectingGeography = {this.onSelectingGeography}
                    onGeographyClickAction = {this.onGeographyClickAction}
                    packageBasePrice = {this.props.productPackageConfig.base_price}
                  />
                }

              </Panel.Body>
            </Panel>
            }
            {
              this.props.productPackageConfig && this.props.productPackageConfig.addons && this.props.productPackageConfig.addons.length > 0 &&
              !(this.props.coupon && this.props.coupon.discountServiceType === 'BundleDiscount') &&
            <Panel eventKey="3">
              <Panel.Heading className={addonsTileClass}>
                <Panel.Title toggle>
                  <div type="button" className="row panel-title panel-button no-margin">
                    <div className="col-xs-7 text-left no-padding">
                      {this.props.productPackageDefaultConfig.configuration.addons.length===0 &&
                        this.state.activeKey==='3' &&
                        <span>
                          <img src={AddonsDefault} alt="" className="margin-right-5"/>
                          <span>Add-Ons</span>
                        </span>
                      }
                      {this.props.productPackageDefaultConfig.configuration.addons.length>0 &&
                        <span>
                          <img src={AddonsActive} alt="" className="margin-right-5"/>
                          <span className="text-success">Add-Ons</span>
                        </span>
                      }
                      {this.props.productPackageDefaultConfig.configuration.addons.length===0 &&
                        this.state.activeKey !== '3' &&
                        <span>
                          <img src={AddonsInactive} alt="" className="margin-right-5"/>
                          <span className="tan-text">Add-Ons</span>
                        </span>
                      }
                    </div>
                    <div className="col-xs-5 text-right no-padding">
                        {
                          this.props.productPackageDefaultConfig.configuration.addons.length>0 &&
                          <span style={{"lineHeight": "30px"}} className="text-success">
                            {this.props.productPackageDefaultConfig.configuration.addons[0]}
                          </span>
                        }
                        {
                          this.props.productPackageDefaultConfig.configuration.addons.length>1 &&
                          <span style={{"lineHeight": "30px"}} className="text-success margin-right-5">
                            +{this.props.productPackageDefaultConfig.configuration.addons.length - 1} more
                          </span>
                        }
                      {this.state.activeKey!=='3' &&
                       this.props.productPackageDefaultConfig.configuration.addons.length===0 &&
                        <span className="panel-dropdown-icon carat-down tan-text" aria-hidden="true"></span>
                      }
                      {this.state.activeKey==='3' && this.props.productPackageDefaultConfig.configuration.addons.length===0 &&
                        <span className="panel-dropdown-icon carat-up" aria-hidden="true"></span>
                      }
                      {this.state.activeKey!=='3' && this.props.productPackageDefaultConfig.configuration.addons.length>0 &&
                        <span className="panel-dropdown-icon carat-down text-success" aria-hidden="true"></span>
                      }
                      {this.state.activeKey==='3' && this.props.productPackageDefaultConfig.configuration.addons.length>0 &&
                        <span className="panel-dropdown-icon carat-up text-success" aria-hidden="true"></span>
                      }
                    </div>
                  </div>
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body collapsible>
                <PackageAddons
                  addons={this.props.productPackageConfig.addons}
                  selectedAddons={this.props.productPackageDefaultConfig.configuration.addons}
                  onSelectingAddons = {this.onSelectingAddons}
                  selectedGeography={this.props.productPackageDefaultConfig.configuration.geography}
                />
              </Panel.Body>
            </Panel>
            }
          </PanelGroup>
        </div>
      </div>
    )
  }
}
